import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import AllHTTPRequests from '@components/obsolete/admin/httprequests/AllHTTPRequests.tsx';

interface ComponentProps {}

const RequestPage: React.FC<ComponentProps> = () => {
  return (
    <AdminLayout title={'Requests'}>
      <AllHTTPRequests />
    </AdminLayout>
  );
};

export default withAuthenticationRequired(RequestPage);
